<template>
  <div class="site">
    <!-- Header -->
    <header class="header" :class="{ scrolled: isScrolled }">
      <div class="header-inner">
        <a class="brand" href="#">
          <img src="./assets/logo.png" alt="EarthSDK" width="32" height="32">
          <span>EarthSDK</span>
        </a>
        <nav class="nav">
          <!-- Group 1: Primary -->
          <a href="https://www.earthsdk.com/earthui/index.html" target="_blank" rel="noopener noreferrer"
            class="nav-primary">立即体验</a>

          <span class="nav-divider" />

          <!-- Group 2: Resources -->
          <div class="nav-group">
            <a href="https://www.earthsdk.com/example3/index.html" target="_blank" rel="noopener noreferrer"
              :class="{ 'nav-active': false }">官方示例</a>
            <a href="https://www.earthsdk.com/docs/guide/index.html" target="_blank" rel="noopener noreferrer"
              :class="{ 'nav-active': false }">API文档</a>
            <a href="#screen-1" :class="{ 'nav-active': activeSection === 'screen-1' }"
              @click.prevent="scrollTo('screen-1')">开发模板</a>
            <a href="#screen-2" :class="{ 'nav-active': activeSection === 'screen-2' }"
              @click.prevent="scrollTo('screen-2')">教程文档</a>
            <a href="#screen-3" :class="{ 'nav-active': activeSection === 'screen-3' }"
              @click.prevent="scrollTo('screen-3')">视频教程</a>
          </div>

          <span class="nav-divider" />

          <!-- Group 3: Community -->
          <div class="nav-group">
            <a href="#footer" :class="{ 'nav-active': activeSection === 'footer' }"
              @click.prevent="scrollTo('footer')">关于我们</a>
            <a href="https://gitee.com/cesiumlab/earthsdk3-code" target="_blank" rel="noopener noreferrer"
              :class="{ 'nav-active': false }">源码仓库</a>
            <a href="https://c0yh9tnn0na.feishu.cn/wiki/Fs9VwaF3Ri2GvMkLVhzc0CDunGd" target="_blank"
              rel="noopener noreferrer" :class="{ 'nav-active': false }">更新日志</a>
          </div>
        </nav>
        <div class="nav-dropdown" @mouseenter="dropdownOpen = true" @mouseleave="dropdownOpen = false">
          <a href="https://bjxbsj.cn/downcenter.html" target="_blank" rel="noopener noreferrer"
            class="nav-dropdown-trigger">
            下载中心
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
              stroke-linecap="round" stroke-linejoin="round" style="margin-left: 4px; transition: transform 0.2s;"
              :style="{ transform: dropdownOpen ? 'rotate(180deg)' : 'rotate(0)' }">
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </a>
          <transition name="dropdown">
            <div v-if="dropdownOpen" class="nav-dropdown-menu">
              <a href="https://bjxbsj.cn/downcenter.html" target="_blank" rel="noopener noreferrer">UE基础场景</a>
              <a href="https://bjxbsj.cn/downcenter.html" target="_blank" rel="noopener noreferrer">ESSS像素流</a>
              <a href="https://bjxbsj.cn/downcenter.html" target="_blank" rel="noopener noreferrer">UE插件</a>
            </div>
          </transition>
        </div>
        <button class="btn-support" @click="supportOpen = !supportOpen">技术支持</button>
        <button class="btn-menu" @click="menuOpen = !menuOpen" aria-label="菜单">
          <span /><span /><span />
        </button>
      </div>
    </header>

    <!-- Mobile Nav -->
    <transition name="slide">
      <nav v-if="menuOpen" class="mobile-nav">
        <div class="mobile-nav-group">
          <a href="https://www.earthsdk.com/earthui/index.html" target="_blank" @click="menuOpen = false"
            class="mobile-nav-primary">立即体验</a>
        </div>
        <div class="mobile-nav-group">
          <div class="mobile-nav-label">资源</div>
          <a href="https://www.earthsdk.com/example3/index.html" target="_blank" @click="menuOpen = false">官方示例</a>
          <a href="https://www.earthsdk.com/docs/guide/index.html" target="_blank" @click="menuOpen = false">API文档</a>
          <a href="#screen-1" @click.prevent="scrollTo('screen-1'); menuOpen = false">开发模板</a>
          <a href="#screen-2" @click.prevent="scrollTo('screen-2'); menuOpen = false">教程文档</a>
          <a href="#screen-3" @click.prevent="scrollTo('screen-3'); menuOpen = false">视频教程</a>
        </div>
        <div class="mobile-nav-group">
          <div class="mobile-nav-label">社区</div>
          <a href="#footer" @click.prevent="scrollTo('footer'); menuOpen = false">关于我们</a>
          <a href="https://gitee.com/cesiumlab/earthsdk3-code" target="_blank" @click="menuOpen = false">源码仓库</a>
          <a href="https://c0yh9tnn0na.feishu.cn/wiki/Fs9VwaF3Ri2GvMkLVhzc0CDunGd" target="_blank"
            @click="menuOpen = false">更新日志</a>
        </div>
        <div class="mobile-nav-group">
          <a href="https://bjxbsj.cn/downcenter.html" target="_blank" @click="menuOpen = false">UE插件下载</a>
          <a href="#" @click.prevent="supportOpen = true; menuOpen = false">技术支持</a>
        </div>
      </nav>
    </transition>

    <!-- Support Modal -->
    <transition name="modal">
      <div v-if="supportOpen" class="modal-mask" @click="supportOpen = false">
        <div class="modal-box" @click.stop>
          <div class="modal-top">
            <h3>技术支持</h3>
            <button @click="supportOpen = false">×</button>
          </div>
          <div class="modal-qr">
            <div class="qr-card">
              <img :src="erweima" alt="公众号二维码" />
              <p>关注微信公众号<br>（地球可视化实验室）<br>提供人工技术支持</p>
            </div>
            <div class="qr-card">
              <img :src="tech" alt="联系人二维码" />
              <p>联系方式：15231988932<br>提供人工技术支持</p>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- UE插件购买浮窗 -->
    <a href="./esforue.html" class="ue-badge">
      <span class="ue-badge-crack ue-badge-crack--tl"></span>
      <span class="ue-badge-crack ue-badge-crack--br"></span>
      <span class="ue-badge-glow"></span>
      <div class="ue-badge-inner">
        <span class="ue-badge-content">
          <span class="ue-badge-tag">UE插件ESForUE</span>
          <span class="ue-badge-divider"></span>
          <span class="ue-badge-price">可源码级授权</span>
        </span>
        <span class="ue-badge-arrow">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </span>
      </div>
    </a>

    <!-- ==================== Screen 1: Hero + Dev Templates ==================== -->
    <section class="screen screen-1" id="screen-1">
      <div class="screen-1-overlay" />
      <div class="screen-1-content">
        <div class="hero">

          <div :style="{ display: '' }">
            <p class="hero-tagline">EarthSDK 地球可视化二次开发框架</p>
            <span class="hero-badge">开源免费</span>
          </div>
          <p class="hero-desc">一套代码，实现 Cesium、UnrealEngine、OpenLayers 多引擎可视化</p>
          <div class="hero-actions">
            <a href="https://www.earthsdk.com/earthui/index.html" target="_blank" class="btn btn-primary">立即体验</a>
            <a href="https://www.earthsdk.com/docs/guide/index.html" target="_blank" class="btn btn-outline">查看文档</a>
          </div>
        </div>
        <div class="templates">
          <div class="template-row">
            <div class="tpl-slot" :class="{ 'is-featured': item.featured }" v-for="(item, i) in modelData" :key="i">
              <span class="tpl-ring" v-if="item.featured" aria-hidden="true"></span>
              <article class="tpl-card" @click="openUrl(item.url)">
                <span class="tpl-badge" v-if="item.featured">推荐</span>
                <div class="tpl-icon"><img :src="item.thumbnail" alt=""></div>
                <h3>{{ item.title }}</h3>
                <p>{{ item.dec }}</p>
              </article>
            </div>
          </div>
        </div>
      </div>
      <div class="scroll-hint" @click="scrollTo('screen-2')">
        <div class="scroll-circle">
          <svg class="scroll-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 5v14" />
            <polyline points="19 12 12 19 5 12" />
          </svg>
        </div>
      </div>
    </section>

    <!-- ==================== Screen 2: Tutorial Documentation ==================== -->
    <section class="screen screen-2" id="screen-2">
      <div class="screen-center">
        <span class="sec-badge">DOCUMENTATION</span>
        <h2 class="sec-title">教程文档</h2>
        <p class="sec-sub">从入门到进阶，全方位学习 EarthSDK</p>
        <div class="doc-grid">
          <article class="doc-card" :class="{ 'doc-card-active': i === 0 }" v-for="(item, i) in docData" :key="i"
            @click="openUrl(item.url)">
            <div class="doc-accent" />
            <div class="doc-num">{{ String(i + 1).padStart(2, '0') }}</div>
            <div class="doc-body">
              <h3>{{ item.title }}</h3>
              <p>{{ item.dec }}</p>
            </div>
            <div class="doc-arrow">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </div>
          </article>
        </div>
      </div>
      <div class="scroll-hint" @click="scrollTo('screen-3')">
        <div class="scroll-circle">
          <svg class="scroll-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 5v14" />
            <polyline points="19 12 12 19 5 12" />
          </svg>
        </div>
      </div>
    </section>

    <!-- ==================== Screen 3: Video + Data Processing ==================== -->
    <section class="screen screen-3" id="screen-3">
      <div class="screen-center">
        <span class="sec-badge">VIDEO</span>
        <h2 class="sec-title">视频教程</h2>
        <p class="sec-sub">观看视频，快速掌握 EarthSDK 实战技巧</p>
        <div class="vid-grid">
          <article class="vid-card" v-for="(item, i) in videoData" :key="i" @click="openUrl(item.url)">
            <div class="vid-thumb">
              <img :src="item.thumbnail" alt="">
              <div class="vid-play">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                  <circle cx="20" cy="20" r="20" fill="rgba(0,0,0,0.45)" />
                  <path d="M16 12l12 8-12 8V12z" fill="#fff" />
                </svg>
              </div>
            </div>
            <div class="vid-info">
              <h3>{{ item.title }}</h3>
              <p>{{ item.dec }}</p>
            </div>
          </article>
        </div>

        <h2 class="sec-title sec-title-sm">更多数据处理</h2>
        <div class="proc-grid">
          <article class="proc-card" v-for="(item, i) in processData" :key="i" :class="{ 'is-new': item.isNew }"
            @click="openUrl(item.url)">
            <span class="badge-new" v-if="item.isNew">NEW</span>
            <h3>{{ item.title }}</h3>
            <p>{{ item.dec }}</p>
          </article>
        </div>
      </div>
      <div class="scroll-hint scroll-hint-up" @click="scrollTo('screen-2')">
        <div class="scroll-circle">
          <svg class="scroll-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 19V5" />
            <polyline points="5 12 12 5 19 12" />
          </svg>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer" id="footer">
      <div class="footer-inner">
        <div class="footer-grid">
          <div class="footer-col" v-for="(col, i) in footerData" :key="i">
            <h4>{{ col.title }}</h4>
            <ul>
              <li v-for="(item, j) in col.items" :key="j">
                <a @click="handleLinkClick(item.url)">{{ item.name }}</a>
              </li>
            </ul>
          </div>
          <div class="footer-col footer-qr">
            <div class="qr-block" v-for="(qr, j) in qrData" :key="j">
              <img :src="qr.image" :alt="qr.alt" width="100" height="100" />
              <p v-html="qr.text"></p>
            </div>
          </div>
        </div>
        <div class="footer-line" />
        <p class="footer-copy">© 2017-2025 北京西部世界科技有限公司 京ICP备17022303号</p>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import html from "./assets/HTML.svg"
import react from "./assets/React+Vite.svg"
import vuevite from "./assets/Vue3+Vite.svg"
import vuewebpack from "./assets/Vue3+Webpack.svg"
import earthui from "./assets/EarthUI.svg"
import aiScaffold from "./assets/AI-Scaffold.svg"
import videoPixel from "./assets/video-pixelstream.svg"
import videoExe from "./assets/video-exe.svg"
import videoUe from "./assets/video-ue.webp"
import videoBeginner from "./assets/video-beginner.svg"
import erweima from "./assets/erweima.jpg"
import tech from "./assets/mingshi.jpg"

const menuOpen = ref(false)
const supportOpen = ref(false)
const dropdownOpen = ref(false)
const isScrolled = ref(false)

// 全屏滚动控制
const isScrolling = ref(false)
const activeSection = ref('screen-1')
const sections = ['screen-1', 'screen-2', 'screen-3', 'footer']

// 滚动状态管理
let scrollState = {
  isAnimating: false,
  lastScrollTime: 0,
  wheelAccumulator: 0,
  pendingScroll: null,
  touchStartY: 0
}

// 检查是否在 section 区域内（允许分页滚动的区域）
function isInSectionArea() {
  const scrollY = window.scrollY
  const viewportHeight = window.innerHeight
  const screen3 = document.getElementById('screen-3')
  if (!screen3) return true

  // 在 screen-3 底部以上 + buffer 区域内
  const threshold = screen3.offsetTop + screen3.offsetHeight - viewportHeight * 0.3
  return scrollY < threshold
}

// 滚动到指定 section
function scrollTo(id) {
  const el = document.getElementById(id)
  if (!el || scrollState.isAnimating) return

  scrollState.isAnimating = true
  isScrolling.value = true
  scrollState.lastScrollTime = Date.now()

  el.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
    inline: 'nearest'
  })

  // 监听滚动结束
  const handleScrollEnd = () => {
    const elapsed = Date.now() - scrollState.lastScrollTime
    if (elapsed >= 600) {
      scrollState.isAnimating = false
      isScrolling.value = false
      window.removeEventListener('scroll', handleScrollEnd)
    }
  }
  window.addEventListener('scroll', handleScrollEnd)

  // 备用定时器确保状态重置
  setTimeout(() => {
    scrollState.isAnimating = false
    isScrolling.value = false
  }, 800)
}

// 获取当前活跃的 section
function getCurrentSection() {
  const viewportHeight = window.innerHeight

  for (const id of sections) {
    const el = document.getElementById(id)
    if (!el) continue

    const rect = el.getBoundingClientRect()
    // 判断 section 的中间区域是否在视口中间
    const sectionMid = rect.top + rect.height / 2
    if (sectionMid >= 0 && sectionMid <= viewportHeight) {
      return id
    }
  }

  // 回退：根据滚动位置判断
  const scrollY = window.scrollY
  for (let i = sections.length - 1; i >= 0; i--) {
    const el = document.getElementById(sections[i])
    if (el && el.offsetTop <= scrollY + viewportHeight * 0.3) {
      return sections[i]
    }
  }

  return sections[0]
}

// 滚轮事件处理
function handleWheel(e) {
  // 弹窗打开时禁止滚动
  if (supportOpen.value || menuOpen.value) return

  // 不在 section 区域时，允许自由滚动
  if (!isInSectionArea()) return

  // 正在动画中，禁止新滚动
  if (scrollState.isAnimating) {
    e.preventDefault()
    return
  }

  const delta = e.deltaY || e.wheelDeltaY || 0

  // 忽略微小的滚动
  if (Math.abs(delta) < 10) return

  e.preventDefault()

  // 累积滚动值，用于判断方向
  scrollState.wheelAccumulator += delta

  // 防抖处理
  if (scrollState.pendingScroll) {
    clearTimeout(scrollState.pendingScroll)
  }

  scrollState.pendingScroll = setTimeout(() => {
    const direction = scrollState.wheelAccumulator > 0 ? 1 : -1
    const currentId = getCurrentSection()
    const currentIndex = sections.indexOf(currentId)
    let nextIndex = -1

    if (direction > 0 && currentIndex < sections.length - 1) {
      // 向下滚动
      nextIndex = currentIndex + 1
    } else if (direction < 0 && currentIndex > 0) {
      // 向上滚动
      nextIndex = currentIndex - 1
    }

    if (nextIndex !== -1 && nextIndex !== currentIndex) {
      scrollTo(sections[nextIndex])
    }

    // 重置累积器
    scrollState.wheelAccumulator = 0
  }, 50)
}

// 触摸滑动处理
function handleTouchStart(e) {
  scrollState.touchStartY = e.touches[0].clientY
}

function handleTouchEnd(e) {
  // 不在 section 区域时，允许自由滚动
  if (!isInSectionArea()) return

  if (scrollState.isAnimating) return

  const touchEndY = e.changedTouches[0].clientY
  const diff = scrollState.touchStartY - touchEndY

  // 忽略微小滑动
  if (Math.abs(diff) < 50) return

  const currentId = getCurrentSection()
  const currentIndex = sections.indexOf(currentId)
  let nextIndex = -1

  if (diff > 0 && currentIndex < sections.length - 1) {
    // 向上滑动（内容向下）
    nextIndex = currentIndex + 1
  } else if (diff < 0 && currentIndex > 0) {
    // 向下滑动（内容向上）
    nextIndex = currentIndex - 1
  }

  if (nextIndex !== -1) {
    scrollTo(sections[nextIndex])
  }
}

// 更新当前 section（用于导航高亮）
function updateActiveSection() {
  if (scrollState.isAnimating) return

  // 不在 section 区域时，不更新 activeSection
  if (!isInSectionArea()) return

  const currentId = getCurrentSection()
  if (currentId !== activeSection.value) {
    activeSection.value = currentId
  }
}

function openUrl(url) {
  if (!url) return
  if (url.startsWith('#')) { scrollTo(url.slice(1)); return }
  window.open(url, '_blank', 'noopener,noreferrer')
}

function handleLinkClick(url) {
  if (url && url !== '#') window.open(url, '_blank')
}

const modelData = ref([
  { title: "AI 脚手架", dec: "AI脚手架工具搭建项目模板", thumbnail: aiScaffold, url: "https://mcnt2750p4zq.feishu.cn/docx/XhT9dyA04oLj7Vx6vZfcyc4Hn2c?from=from_copylink", featured: true },
  { title: "Html", dec: "纯HTML/JS轻量开发模板", thumbnail: html, url: "https://gitee.com/cesiumlab/earthsdk3-demos/tree/master/examples/earthsdk3-html" },
  { title: "Vue3+Vite", dec: "Vue3配合Vite快速构建模板", thumbnail: vuevite, url: "https://gitee.com/cesiumlab/earthsdk3-demos/tree/master/examples/earthsdk3-vite" },
  { title: "Vue3+Webpack", dec: "Vue3配合Webpack构建模板", thumbnail: vuewebpack, url: "https://gitee.com/cesiumlab/earthsdk3-demos/tree/master/examples/earthsdk3-wbpk" },
  { title: "React+Vite", dec: "React配合Vite快速构建模板", thumbnail: react, url: "https://gitee.com/cesiumlab/earthsdk3-demos/tree/master/examples/earthsdk3-react-vite" },
  { title: "EarthUI（低代码平台）", dec: "开箱即用的可视化UI模板", thumbnail: earthui, url: "https://gitee.com/cesiumlab/earthsdk3-demos/tree/master/demos/earthui" },
])

const docData = ref([
  { title: "UE场景搭建", dec: "在UnrealEngine引入EarthSDK插件。", url: "https://ng627s0rel.feishu.cn/docx/XzxLdpe6YoMPV9xu5pscmX2Fn9f" },
  { title: "初学者教程（前端）", dec: "从零开始学习，快速上手EarthSDK。", url: "https://c0yh9tnn0na.feishu.cn/wiki/NcIww74yTiNq0EkVxszc5XtOnqf#share-RZXjdknWXoippSxthbYcUtlBn6g" },
  { title: "加载自定义 Actor", dec: "在SDK种加载UE自定义的Actor。", url: "https://ng627s0rel.feishu.cn/docx/NQCGdAo9wozBbWxdj32cYsytnSf" },
  { title: "加载自定义 Widget（UMG）", dec: "在EarthSDK中加载UE自定义 UMG。", url: "https://ng627s0rel.feishu.cn/docx/IA1ZdRnoeoOuzVxZWiOcj9uXnzg" },
  { title: "JS 与 UE 自定义消息通道", dec: "自定义UE和JS端通信与消息机制。", url: "https://ng627s0rel.feishu.cn/docx/YJgRdM3sYoSG77x6xgocRUYLnnc" },
  { title: "PAK 打包", dec: "如何PAK打包,并且在SDK中加载。", url: "https://ng627s0rel.feishu.cn/docx/JkqzdBIwvoyBjQxN6rfccdNnnnf" },
  { title: "3DTiles数据—UE材质替换", dec: "在 UE 中为 3DTiles 数据替换自定义材质。", url: "https://my.feishu.cn/docx/TM0OdCjHOoK24Lxc8SychtPynPd?from=from_copylink" }
])

const videoData = ref([
  { title: "像素流模式", dec: "EarthSDK像素流模式演示", thumbnail: videoPixel, url: "https://www.bilibili.com/video/BV17m411Z72S/" },
  { title: "大屏EXE模式", dec: "EarthSDK本地大屏exe模式演示", thumbnail: videoExe, url: "https://www.bilibili.com/video/BV1N1421S7uc/" },
  { title: "UE场景搭建", dec: "在UnrealEngine引入EarthSDK插件", thumbnail: videoUe, url: "https://www.bilibili.com/video/BV1yw4m1d7Q4/" },
  { title: "初学者教程合集", dec: "系统学习EarthSDK", thumbnail: videoBeginner, url: "https://space.bilibili.com/346212872/lists/2348836?type=season" }
])

const processData = ref([
  { title: 'CesiumLab', dec: '地理信息集成数据处理平台', url: 'https://bjxbsj.cn/cesiumlab.html', isNew: false },
  { title: 'PipeSer', dec: '管线管理及服务', url: 'https://bjxbsj.cn/pipeser.html', isNew: false },
  { title: 'ModelSer', dec: '分布式倾斜数据管理云平台', url: 'https://bjxbsj.cn/modelser.html', isNew: true },
  { title: 'ESDS', dec: '数据交换及服务系统', url: 'https://bjxbsj.cn/esds.html', isNew: false },
  { title: 'CIMRTS', dec: '城市信息模型实时服务平台', url: 'https://bjxbsj.cn/cimrts.html', isNew: true },
  { title: 'TerrainRTS', dec: '地形渲染数据实时分发平台', url: 'https://bjxbsj.cn/terrainrts.html', isNew: true }
])

const footerData = ref([
  {
    title: "企业产品",
    items: [
      { name: "Cesiumlab地理信息集成数据处理平台", url: "https://bjxbsj.cn/cesiumlab.html" },
      { name: "PipeSer管线管理及服务", url: "https://bjxbsj.cn/pipeser.html" },
      { name: "ModelSer分布式裸模数据管理云平台", url: "https://bjxbsj.cn/modelser.html" },
      { name: "EarthSDK地球可视化开发包", url: "https://www.earthsdk.com/#/" },
      { name: "ESWebView插件", url: "https://bjxbsj.cn/eswebview.html" },
      { name: "ESSS设备服务器", url: "https://bjxbsj.cn/esss.html" }
    ]
  },
  {
    title: "服务支持",
    items: [
      { name: "智慧港口解决方案", url: "https://bjxbsj.cn/portsolution.html" },
      { name: "智慧林业解决方案", url: "https://bjxbsj.cn/forestrysoslution.html" },
      { name: "大数据驱动型可视化方案定制", url: "https://bjxbsj.cn/datasolution.html" },
      { name: "场景建模与设计", url: "http://www.huanshu3d.com:8080/#/home" },
      { name: "技术支持", url: "https://bjxbsj.cn/tech.html" }
    ]
  },
  {
    title: "产品购买",
    items: [
      { name: "Cesiumlab", url: "https://bjxbsj.cn/purchase.html" },
      { name: "PipeSer", url: "https://bjxbsj.cn/purchase.html" },
      { name: "ModelSer", url: "https://bjxbsj.cn/purchase.html" },
      { name: "EarthSDK", url: "https://bjxbsj.cn/purchase.html" },
      { name: "ESWebView", url: "https://bjxbsj.cn/purchase.html" },
      { name: "ESSS", url: "https://bjxbsj.cn/purchase.html" }
    ]
  },
  {
    title: "关于我们",
    items: [
      { name: "技术支持", url: "https://bjxbsj.cn/tech.html" },
      { name: "商务合作：16619955894（苏经理）", url: "https://bjxbsj.cn/tech.html" },
      { name: "工作日：9:00 - 18:30", url: "https://bjxbsj.cn/tech.html" }
    ]
  }
])

const qrData = ref([
  { image: erweima, alt: "公众号二维码", text: "关注微信公众号<br/>（地球可视化实验室）<br/>提供人工技术支持" }
])

let sectionObserver = null
let scrollRAF = null

onMounted(() => {
  // 初始化 activeSection
  activeSection.value = getCurrentSection()

  // 使用 IntersectionObserver 监听 section 可见性变化
  sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.3) {
          activeSection.value = entry.target.id
        }
      })
    },
    {
      rootMargin: '-30% 0px -30% 0px',
      threshold: [0, 0.3, 0.5, 0.7, 1]
    }
  )

  sections.forEach((id) => {
    const el = document.getElementById(id)
    if (el) sectionObserver.observe(el)
  })

  // 监听滚动更新导航状态（节流）
  window.addEventListener('scroll', () => {
    if (scrollRAF) return
    scrollRAF = requestAnimationFrame(() => {
      updateActiveSection()
      scrollRAF = null
    })
  }, { passive: true })

  // 添加滚轮事件监听（被动：false 以允许 preventDefault）
  window.addEventListener('wheel', handleWheel, { passive: false })

  // 触摸事件
  window.addEventListener('touchstart', handleTouchStart, { passive: true })
  window.addEventListener('touchend', handleTouchEnd, { passive: true })

  // Header scroll effect
  window.addEventListener('scroll', () => {
    isScrolled.value = window.scrollY > 20
  }, { passive: true })
})

onUnmounted(() => {
  if (sectionObserver) sectionObserver.disconnect()
  if (scrollRAF) cancelAnimationFrame(scrollRAF)
  if (scrollState.pendingScroll) clearTimeout(scrollState.pendingScroll)
  window.removeEventListener('wheel', handleWheel)
  window.removeEventListener('touchstart', handleTouchStart)
  window.removeEventListener('touchend', handleTouchEnd)
})
</script>

<style>
/* ===== Variables & Reset ===== */
:root {
  --c-dark: #070b14;
  --c-dark-2: #0d1221;
  --c-white: #ffffff;
  --c-light: #f8fafc;
  --c-subtle: #f1f5f9;
  --c-accent: #3b82f6;
  --c-accent-l: #60a5fa;
  --c-accent-d: #2563eb;
  --c-violet: #8b5cf6;
  --c-text: #0f172a;
  --c-text-2: #475569;
  --c-text-3: #94a3b8;
  --c-border: #e2e8f0;
  --c-border-d: #1e293b;
  --font: 'Source Han Sans CN', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  --hh: 68px;
  --r: 14px;
  --ease: cubic-bezier(0.4, 0, 0.2, 1);
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-y: scroll;
}

html::-webkit-scrollbar {
  display: none;
}

html.smooth-scroll {
  scroll-behavior: smooth;
}

body {
  font-family: var(--font);
  color: var(--c-text);
  background: var(--c-white);
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}

a {
  text-decoration: none;
  color: inherit;
}

img {
  display: block;
  max-width: 100%;
}

/* ===== Header ===== */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--hh);
  background: rgba(7, 11, 20, 0.88);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  z-index: 100;
}

.header-inner {
  max-width: 1600px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 48px;
  gap: 20px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.brand span {
  font-size: 22px;
  font-weight: 700;
  color: var(--c-white);
  letter-spacing: 0.5px;
}

.nav {
  display: flex;
  align-items: center;
  gap: 0;
  margin-left: 48px;
}

.nav-primary {
  font-size: 16px;
  font-weight: 600;
  color: var(--c-white);
  transition: color 0.2s var(--ease);
  white-space: nowrap;
  position: relative;
  padding-bottom: 8px;
}

.nav-primary::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, var(--c-accent-l), var(--c-violet));
  border-radius: 2px;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.25s var(--ease);
}

.nav-primary:hover {
  color: var(--c-white);
}

.nav-primary:hover::after {
  transform: scaleX(1);
}

.nav-divider {
  width: 1px;
  height: 18px;
  background: rgba(255, 255, 255, 0.18);
  margin: 0 28px;
  flex-shrink: 0;
}

.nav-group {
  display: flex;
  align-items: center;
  gap: 32px;
}

.nav>a:not(.nav-primary),
.nav-group>a {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.72);
  transition: color 0.2s var(--ease);
  white-space: nowrap;
  position: relative;
  padding-bottom: 8px;
  display: inline-block;
}

.nav>a:not(.nav-primary)::after,
.nav-group>a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, var(--c-accent-l), var(--c-violet));
  border-radius: 2px;
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.25s var(--ease);
}

.nav>a:not(.nav-primary):hover,
.nav-group>a:hover {
  color: var(--c-white);
}

.nav>a:not(.nav-primary):hover::after,
.nav-group>a:hover::after {
  transform: scaleX(1);
}

.nav>a:not(.nav-primary).nav-active,
.nav-group>a.nav-active {
  color: var(--c-white);
}

.nav>a:not(.nav-primary).nav-active::after,
.nav-group>a.nav-active::after {
  transform: scaleX(1);
}

/* Dropdown */
.nav-dropdown {
  position: relative;
  flex-shrink: 0;
  margin-left: auto;
}

.nav-dropdown-trigger {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.75);
  transition: color 0.2s var(--ease);
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}

.nav-dropdown-trigger:hover {
  color: var(--c-white);
}

.nav-dropdown-menu {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 200px;
  background: rgba(13, 18, 33, 0.96);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  z-index: 101;
}

.nav-dropdown-menu a {
  display: block;
  padding: 12px 16px;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  border-radius: 8px;
  transition: all 0.2s var(--ease);
  white-space: nowrap;
}

.nav-dropdown-menu a:hover {
  background: rgba(59, 130, 246, 0.15);
  color: var(--c-white);
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.2s var(--ease);
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-8px);
}

.btn-support {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 22px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: var(--c-white);
  border: none;
  border-radius: 10px;
  cursor: pointer;
  background-color: var(--c-accent);
  background-image:
    linear-gradient(180deg, rgba(255, 255, 255, 0.22) 0%, transparent 45%),
    linear-gradient(180deg, var(--c-accent) 0%, var(--c-accent-d) 100%);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.4) inset,
    0 -1px 0 rgba(0, 0, 0, 0.18) inset,
    0 1px 0 rgba(37, 99, 235, 0.6),
    0 4px 12px rgba(59, 130, 246, 0.3),
    0 8px 24px rgba(139, 92, 246, 0.12);
  transition: transform 0.3s var(--ease), box-shadow 0.3s var(--ease);
  overflow: hidden;
  isolation: isolate;
  flex-shrink: 0;
}

.btn-support::before {
  content: '';
  position: absolute;
  top: 0;
  left: -120%;
  width: 70%;
  height: 100%;
  background: linear-gradient(120deg, transparent 0%, rgba(255, 255, 255, 0.5) 50%, transparent 100%);
  transform: skewX(-22deg);
  transition: left 0.7s var(--ease);
  z-index: 1;
  pointer-events: none;
}

.btn-support>* {
  position: relative;
  z-index: 2;
}

.btn-support:hover {
  transform: translateY(-1px);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.45) inset,
    0 -1px 0 rgba(0, 0, 0, 0.2) inset,
    0 2px 0 rgba(37, 99, 235, 0.55),
    0 8px 18px rgba(59, 130, 246, 0.45),
    0 14px 36px rgba(139, 92, 246, 0.22);
}

.btn-support:hover::before {
  left: 130%;
}

.btn-support:active {
  transform: translateY(0.5px);
}

.btn-menu {
  display: none;
  flex-direction: column;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  margin-left: auto;
}

.btn-menu span {
  display: block;
  width: 26px;
  height: 2.5px;
  background: var(--c-white);
  border-radius: 2px;
  transition: all 0.3s var(--ease);
}

/* ===== UE Badge — 破墙而出 ===== */
.ue-badge {
  position: fixed;
  top: calc(var(--hh) + 50px);
  right: 54px;
  z-index: 90;
  cursor: pointer;
  text-decoration: none;
  isolation: isolate;
  /* 整体微旋转，制造"歪斜破出"感 */
  transform: rotate(-1.5deg);
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}

.ue-badge:hover {
  transform: rotate(-1.5deg) translateY(-3px) scale(1.04);
}

.ue-badge-inner {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 14px;
  padding: 14px 24px 14px 22px;
  /* 主体渐变：暗紫蓝 → 深红橙 → 暗紫蓝（破洞后透出的光） */
  background:
    linear-gradient(135deg, #1a1a2e 0%, #2a1810 45%, #4a2511 55%, #1a1a2e 100%);
  /* 不规则多边形，破墙撕扯感 */
  clip-path: polygon(4% 0%, 12% 6%, 22% 2%, 30% 8%, 42% 3%, 55% 9%, 68% 4%, 78% 10%,
      90% 5%, 96% 14%, 100% 28%, 97% 42%, 100% 56%, 95% 72%, 100% 86%,
      92% 100%, 78% 96%, 62% 100%, 48% 95%, 32% 100%, 18% 94%, 6% 100%,
      0% 84%, 3% 68%, 0% 52%, 4% 36%, 0% 20%);
  /* 强力立体投影：被砸出凹陷感 */
  filter: drop-shadow(0 2px 0 rgba(0, 0, 0, 0.6)) drop-shadow(0 8px 12px rgba(0, 0, 0, 0.55)) drop-shadow(0 16px 30px rgba(0, 0, 0, 0.4));
  transition: filter 0.3s ease;
}

.ue-badge:hover .ue-badge-inner {
  filter: drop-shadow(0 2px 0 rgba(0, 0, 0, 0.6)) drop-shadow(0 12px 18px rgba(0, 0, 0, 0.65)) drop-shadow(0 22px 40px rgba(0, 0, 0, 0.5)) drop-shadow(0 0 24px rgba(255, 170, 0, 0.45));
}

/* 边缘高光 — 模拟被撕开时露出的金属/亮面 */
.ue-badge-inner::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    /* 顶部高光 */
    linear-gradient(180deg, rgba(255, 215, 0, 0.45) 0%, transparent 18%),
    /* 左侧高光 */
    linear-gradient(90deg, rgba(255, 255, 255, 0.25) 0%, transparent 12%),
    /* 底部暗影 */
    linear-gradient(0deg, rgba(0, 0, 0, 0.5) 0%, transparent 25%),
    /* 右侧暗影 */
    linear-gradient(270deg, rgba(0, 0, 0, 0.4) 0%, transparent 15%);
  pointer-events: none;
  z-index: 1;
  /* 与父级一致的破洞形状 */
  clip-path: polygon(4% 0%, 12% 6%, 22% 2%, 30% 8%, 42% 3%, 55% 9%, 68% 4%, 78% 10%,
      90% 5%, 96% 14%, 100% 28%, 97% 42%, 100% 56%, 95% 72%, 100% 86%,
      92% 100%, 78% 96%, 62% 100%, 48% 95%, 32% 100%, 18% 94%, 6% 100%,
      0% 84%, 3% 68%, 0% 52%, 4% 36%, 0% 20%);
}

/* 内容层在所有效果之上 */
.ue-badge-inner>* {
  position: relative;
  z-index: 2;
}

.ue-badge-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: radial-gradient(circle at 30% 30%, #fff4a3 0%, #ffd700 40%, #ff8800 100%);
  border-radius: 50%;
  color: #1a1a2e;
  flex-shrink: 0;
  box-shadow:
    0 0 0 2px rgba(255, 215, 0, 0.3),
    0 0 12px rgba(255, 170, 0, 0.6),
    inset 0 1px 2px rgba(255, 255, 255, 0.6);
  transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
  animation: ueIconPulse 2s ease-in-out infinite;
}

.ue-badge:hover .ue-badge-icon {
  transform: rotate(72deg) scale(1.1);
  animation-play-state: paused;
}

@keyframes ueIconPulse {

  0%,
  100% {
    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.3), 0 0 12px rgba(255, 170, 0, 0.6), inset 0 1px 2px rgba(255, 255, 255, 0.6);
  }

  50% {
    box-shadow: 0 0 0 3px rgba(255, 215, 0, 0.5), 0 0 20px rgba(255, 170, 0, 0.9), inset 0 1px 2px rgba(255, 255, 255, 0.6);
  }
}

.ue-badge-content {
  display: inline-flex;
  align-items: center;
  gap: 14px;
}

.ue-badge-tag {
  font-size: 17px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.ue-badge-divider {
  width: 1px;
  height: 18px;
  background: linear-gradient(180deg, transparent, rgba(255, 215, 0, 0.6), transparent);
  box-shadow: 0 0 4px rgba(255, 215, 0, 0.4);
}

.ue-badge-price {
  font-size: 16px;
  font-weight: 700;
  background: linear-gradient(135deg, #fff4a3 0%, #ffd700 50%, #ff8800 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: 0.2px;
  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.5));
}

.ue-badge-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffd700;
  margin-left: 2px;
  transition: all 0.3s ease;
  filter: drop-shadow(0 0 4px rgba(255, 215, 0, 0.5));
}

.ue-badge-arrow svg {
  width: 18px;
  height: 18px;
}

.ue-badge:hover .ue-badge-arrow {
  color: #fff4a3;
  transform: translateX(4px);
  filter: drop-shadow(0 0 8px rgba(255, 215, 0, 0.9));
}

/* 破洞金光透出 */
.ue-badge-glow {
  position: absolute;
  inset: -28px;
  background: radial-gradient(ellipse at center, rgba(255, 170, 0, 0.6) 0%, rgba(255, 100, 0, 0.25) 30%, transparent 65%);
  z-index: -1;
  pointer-events: none;
  animation: ueBadgePulse 1.8s ease-in-out infinite;
  filter: blur(16px);
}

.ue-badge:hover .ue-badge-glow {
  opacity: 1.3;
  animation-play-state: paused;
}

@keyframes ueBadgePulse {

  0%,
  100% {
    opacity: 0.5;
    transform: scale(0.9);
  }

  50% {
    opacity: 0.95;
    transform: scale(1.1);
  }
}

/* 破洞裂缝 — 左上 */
.ue-badge-crack {
  position: absolute;
  z-index: 3;
  pointer-events: none;
  opacity: 0.9;
}

.ue-badge-crack--tl {
  top: -40px;
  left: -22px;
  width: 68px;
  height: 68px;
  background: linear-gradient(135deg, transparent 48%, rgba(255, 215, 0, 0.95) 50%, rgba(255, 170, 0, 0.7) 100%);
  clip-path: polygon(0 0, 100% 0, 0 100%, 30% 60%, 60% 35%);
  filter: drop-shadow(0 0 4px rgba(255, 170, 0, 0.8));
  transform: rotate(-25deg);
}

.ue-badge-crack--br {
  bottom: -8px;
  right: -10px;
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, rgba(255, 170, 0, 0.7) 0%, rgba(255, 215, 0, 0.95) 50%, transparent 52%);
  clip-path: polygon(100% 100%, 0 100%, 100% 0, 70% 40%, 40% 65%);
  filter: drop-shadow(0 0 4px rgba(255, 170, 0, 0.8));
  transform: rotate(15deg);
}

/* ===== Mobile Nav ===== */
.mobile-nav {
  position: fixed;
  top: var(--hh);
  left: 0;
  right: 0;
  display: none;
  flex-direction: column;
  padding: 8px 28px 24px;
  background: rgba(7, 11, 20, 0.96);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  z-index: 99;
  gap: 4px;
}

.mobile-nav-group {
  display: flex;
  flex-direction: column;
}

.mobile-nav-label {
  padding: 18px 0 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.3);
  text-transform: uppercase;
}

.mobile-nav-group:first-child .mobile-nav-label {
  padding-top: 8px;
}

.mobile-nav a {
  padding: 13px 0;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  transition: color 0.2s;
}

.mobile-nav a:hover {
  color: var(--c-accent-l);
}

.mobile-nav-primary {
  font-weight: 600;
  color: var(--c-white);
}

/* ===== Modal ===== */
.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  padding: 24px;
}

.modal-box {
  background: var(--c-white);
  border-radius: 20px;
  padding: 36px;
  max-width: 560px;
  width: 100%;
  box-shadow: var(--shadow-xl);
  animation: modalIn 0.35s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modalIn {
  from {
    opacity: 0;
    transform: scale(0.94) translateY(-16px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--c-border);
}

.modal-top h3 {
  font-size: 22px;
  font-weight: 700;
  color: var(--c-text);
}

.modal-top button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: var(--c-subtle);
  font-size: 20px;
  color: var(--c-text-2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  line-height: 1;
}

.modal-top button:hover {
  background: #fee2e2;
  color: #ef4444;
}

.modal-qr {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.qr-card {
  text-align: center;
  padding: 24px;
  border-radius: var(--r);
  background: var(--c-light);
  border: 1px solid var(--c-border);
}

.qr-card img {
  width: 140px;
  height: 140px;
  border-radius: 12px;
  margin: 0 auto 14px;
  box-shadow: var(--shadow-sm);
}

.qr-card p {
  font-size: 13px;
  color: var(--c-text-2);
  line-height: 1.6;
}

/* ===== Screens (common) ===== */
.screen {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

@media (prefers-reduced-motion: no-preference) {
  html {
    scroll-behavior: smooth;
  }
}

/* ===== Screen 1: Hero + Templates ===== */
.screen-1 {
  background: #050a18;
  padding-top: var(--hh);
  flex-direction: column;
  overflow: hidden;
}

.screen-1::before {
  content: '';
  position: absolute;
  inset: 0;
  background: url('./assets/banner.webp') center/cover no-repeat;
  opacity: 0.12;
  z-index: 0;
}

.screen-1::after {
  content: '';
  position: absolute;
  bottom: -15%;
  left: -8%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.07) 0%, transparent 70%);
  border-radius: 50%;
  z-index: 1;
  pointer-events: none;
  animation: hero-orb-2 28s ease-in-out infinite;
}

.screen-1-overlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  pointer-events: none;
  background:
    radial-gradient(ellipse 90% 55% at 50% -15%, rgba(59, 130, 246, 0.18) 0%, transparent 70%),
    radial-gradient(ellipse 50% 50% at 8% 100%, rgba(139, 92, 246, 0.12) 0%, transparent 55%),
    radial-gradient(ellipse 40% 35% at 92% 40%, rgba(59, 130, 246, 0.08) 0%, transparent 50%),
    linear-gradient(180deg, transparent 0%, rgba(5, 10, 24, 0.5) 100%);
}

.screen-1-overlay::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 48px 48px;
  -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 45%, black 20%, transparent 70%);
  mask-image: radial-gradient(ellipse 70% 60% at 50% 45%, black 20%, transparent 70%);
}

.screen-1-overlay::after {
  content: '';
  position: absolute;
  top: -18%;
  right: -12%;
  width: 700px;
  height: 700px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.07) 0%, transparent 70%);
  border-radius: 50%;
  animation: hero-orb-1 24s ease-in-out infinite;
}

@keyframes hero-orb-1 {

  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  33% {
    transform: translate(-70px, 50px) scale(1.08);
  }

  66% {
    transform: translate(35px, -35px) scale(0.95);
  }
}

@keyframes hero-orb-2 {

  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(50px, -45px) scale(1.12);
  }
}

.screen-1-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 42px;
  padding: 0px 40px 50px;
  width: 100%;
  max-width: 1500px;
}

.hero {
  text-align: center;
}

.hero-badge {
  position: absolute;
  right: 140px;
  top: 40px;
  display: inline-block;
  padding: 5px 20px;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.25);
  border-radius: 50px;
  color: var(--c-accent-l);
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 32px;
}

.hero-title {
  font-size: clamp(48px, 8vw, 88px);
  font-weight: 800;
  background-color: rgba(255, 255, 255, 0.9);
  /* background: linear-gradient(135deg, #fff 20%, var(--c-accent-l) 60%, var(--c-violet) 100%); */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.1;
  margin-bottom: 16px;
}

.hero-tagline {
  font-size: clamp(22px, 3vw, 56px);
  font-weight: 800;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 20px;
}

.hero-desc {
  font-size: clamp(15px, 1.5vw, 21px);
  color: rgba(255, 255, 255, 0.55);
  margin-bottom: 44px;
  letter-spacing: 0.5px;
}

.hero-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px 40px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.35s var(--ease);
  border: none;
  overflow: hidden;
  isolation: isolate;
}

.btn>* {
  position: relative;
  z-index: 2;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -120%;
  width: 80%;
  height: 100%;
  background: linear-gradient(120deg, transparent 0%, rgba(255, 255, 255, 0.45) 50%, transparent 100%);
  transform: skewX(-22deg);
  transition: left 0.7s var(--ease);
  z-index: 1;
  pointer-events: none;
}

.btn:hover::before {
  left: 130%;
}

.btn-primary {
  background-color: var(--c-accent);
  background-image:
    linear-gradient(180deg, rgba(255, 255, 255, 0.22) 0%, transparent 45%),
    linear-gradient(180deg, var(--c-accent) 0%, var(--c-accent-d) 100%);
  color: var(--c-white);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.4) inset,
    0 -2px 0 rgba(0, 0, 0, 0.18) inset,
    0 2px 0 rgba(37, 99, 235, 0.6),
    0 8px 24px rgba(59, 130, 246, 0.35),
    0 16px 40px rgba(139, 92, 246, 0.18);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.45) inset,
    0 -2px 0 rgba(0, 0, 0, 0.2) inset,
    0 4px 0 rgba(37, 99, 235, 0.55),
    0 14px 32px rgba(59, 130, 246, 0.5),
    0 24px 60px rgba(139, 92, 246, 0.28);
}

.btn-primary:active {
  transform: translateY(1px);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.4) inset,
    0 -1px 0 rgba(0, 0, 0, 0.2) inset,
    0 1px 0 rgba(37, 99, 235, 0.6),
    0 4px 12px rgba(59, 130, 246, 0.4);
}

.btn-outline {
  background: rgba(255, 255, 255, 0.06);
  color: var(--c-white);
  border: 1px solid rgba(255, 255, 255, 0.22);
  backdrop-filter: blur(8px);
}

.btn-outline:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.45);
  transform: translateY(-2px);
}

.templates {
  width: 100%;
  text-align: center;
  animation: templatesFadeUp 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s both;
}

@keyframes templatesFadeUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.template-row {
  margin-top: 50px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.tpl-slot {
  position: relative;
  min-width: 0;
}

.tpl-card {
  position: relative;
  height: 100%;
  padding: 0;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: var(--r);
  cursor: pointer;
  transition: all 0.35s var(--ease);
  text-align: center;
  backdrop-filter: blur(8px);
  overflow: hidden;
}

.tpl-card:hover {
  background: rgba(255, 255, 255, 0.09);
  border-color: rgba(59, 130, 246, 0.4);
  transform: translateY(-8px);
  box-shadow:
    0 16px 40px rgba(59, 130, 246, 0.2),
    0 0 0 1px rgba(59, 130, 246, 0.15);
}

.tpl-slot.is-featured {
  z-index: 2;
}

.tpl-slot.is-featured .tpl-card {
  border-color: rgba(129, 140, 248, 0.45);
}

.tpl-slot.is-featured .tpl-card:hover {
  border-color: rgba(129, 140, 248, 0.7);
}

.tpl-slot.is-featured .tpl-card h3 {
  color: #c7d2fe;
}

.tpl-slot.is-featured .tpl-card:hover h3 {
  color: #e0e7ff;
}

.tpl-ring {
  position: absolute;
  inset: -3px;
  border-radius: calc(var(--r) + 3px);
  pointer-events: none;
  z-index: 0;
  background: conic-gradient(
    from var(--tpl-angle, 0deg),
    rgba(99, 102, 241, 0.15) 0%,
    rgba(99, 102, 241, 0.15) 55%,
    #818cf8 68%,
    #38bdf8 78%,
    #ffffff 86%,
    #818cf8 94%,
    rgba(99, 102, 241, 0.15) 100%
  );
  animation: tplRingSpin 2.6s linear infinite;
  filter: drop-shadow(0 0 8px rgba(99, 102, 241, 0.7))
          drop-shadow(0 0 16px rgba(56, 189, 248, 0.4));
  -webkit-mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  mask:
    linear-gradient(#fff 0 0) content-box,
    linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  padding: 3px;
  transition: transform 0.35s var(--ease);
}

.tpl-slot.is-featured:hover .tpl-ring {
  transform: translateY(-8px);
}

.tpl-slot.is-featured .tpl-card {
  position: relative;
  z-index: 1;
}

.tpl-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  padding: 4px 10px;
  background: linear-gradient(135deg, #6366f1, #0ea5e9);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 14px rgba(99, 102, 241, 0.45);
}

@property --tpl-angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes tplRingSpin {
  to { --tpl-angle: 360deg; }
}

.tpl-icon {
  width: 100%;
  height: 150px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.03);
}

.tpl-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s var(--ease);
}

.tpl-card:hover .tpl-icon img {
  transform: scale(1.06);
}

.tpl-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--c-white);
  margin-bottom: 4px;
  padding: 18px 16px 0;
  transition: color 0.3s;
}

.tpl-card:hover h3 {
  color: var(--c-accent-l);
}

.tpl-card p {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1.5;
  padding: 0 16px 18px;
}

.scroll-hint {
  position: absolute;
  bottom: 36px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
  cursor: pointer;
}

.scroll-circle {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.3s, background 0.3s, box-shadow 0.3s;
}

.scroll-arrow {
  color: rgba(255, 255, 255, 0.75);
  animation: arrowDown 2s ease-in-out infinite;
  transition: color 0.3s;
}

.scroll-hint:hover .scroll-circle {
  border-color: rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 14px rgba(255, 255, 255, 0.15);
}

.scroll-hint:hover .scroll-arrow {
  color: #fff;
}

.screen-2 .scroll-circle {
  border-color: rgba(0, 0, 0, 0.2);
}

.screen-2 .scroll-arrow {
  color: rgba(0, 0, 0, 0.35);
}

.screen-2 .scroll-hint {
  bottom: 100px;
}

.screen-2 .scroll-hint:hover .scroll-circle {
  border-color: rgba(0, 0, 0, 0.4);
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.08);
}

.screen-2 .scroll-hint:hover .scroll-arrow {
  color: rgba(0, 0, 0, 0.6);
}

.screen-3 .scroll-hint {
  bottom: 100px;
}

.screen-3 .scroll-hint-up {
  bottom: 36px;
}

.screen-3 .scroll-hint:hover .scroll-circle {
  border-color: rgba(0, 0, 0, 0.4);
  background: rgba(0, 0, 0, 0.04);
  box-shadow: 0 0 14px rgba(0, 0, 0, 0.08);
}

.screen-3 .scroll-hint:hover .scroll-arrow {
  color: rgba(0, 0, 0, 0.6);
}

.screen-3 .scroll-arrow {
  animation: arrowUp 2s ease-in-out infinite;
}

@keyframes arrowDown {

  0%,
  100% {
    transform: translateY(-3px);
    opacity: 0.5;
  }

  50% {
    transform: translateY(3px);
    opacity: 1;
  }
}

@keyframes arrowUp {

  0%,
  100% {
    transform: translateY(3px);
    opacity: 0.5;
  }

  50% {
    transform: translateY(-3px);
    opacity: 1;
  }
}

/* ===== Screen 2: Documentation ===== */
.screen-2 {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 50%, #f8fafc 100%);
  position: relative;
  overflow: hidden;
}

.screen-2::before {
  content: '';
  position: absolute;
  top: -200px;
  right: -200px;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(59, 130, 246, 0.06) 0%, transparent 70%);
  pointer-events: none;
}

.screen-2::after {
  content: '';
  position: absolute;
  bottom: -200px;
  left: -200px;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, rgba(139, 92, 246, 0.05) 0%, transparent 70%);
  pointer-events: none;
}

.screen-center {
  width: 100%;
  max-width: 1400px;
  padding: 100px 40px;
  margin: -100px auto 0;
  position: relative;
  z-index: 1;
}

.sec-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 4px;
  color: var(--c-accent);
  margin-bottom: 16px;
  padding: 5px 14px;
  background: rgba(59, 130, 246, 0.06);
  border: 1px solid rgba(59, 130, 246, 0.12);
  border-radius: 50px;
}

.sec-title {
  font-size: 42px;
  font-weight: 800;
  color: var(--c-text);
  text-align: center;
  margin-bottom: 14px;
  letter-spacing: -0.5px;
}

.sec-sub {
  font-size: 17px;
  color: var(--c-text-2);
  text-align: center;
  margin-bottom: 60px;
}

.sec-title-sm {
  font-size: 28px;
  margin-top: 80px;
  margin-bottom: 36px;
  font-weight: 700;
}

.doc-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.doc-card {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 28px 28px;
  background: var(--c-white);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: var(--r);
  cursor: pointer;
  transition: all 0.35s var(--ease);
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.doc-accent {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, var(--c-accent), var(--c-violet));
  border-radius: 0 4px 4px 0;
  opacity: 0;
  transition: opacity 0.35s var(--ease);
}

.doc-card:hover .doc-accent {
  opacity: 1;
}

.doc-card:hover {
  border-color: transparent;
  box-shadow: var(--shadow-lg);
  transform: translateY(-4px);
  background: var(--c-white);
}

.doc-num {
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  font-size: 20px;
  font-weight: 800;
  color: var(--c-accent);
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.08), rgba(139, 92, 246, 0.08));
  flex-shrink: 0;
  transition: all 0.35s var(--ease);
}

.doc-card:hover .doc-num {
  background: linear-gradient(135deg, var(--c-accent), var(--c-violet));
  color: var(--c-white);
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
  transform: scale(1.05);
}

.doc-body {
  flex: 1;
  text-align: left;
}

.doc-body h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--c-text);
  margin-bottom: 6px;
  transition: color 0.3s;
}

.doc-card:hover .doc-body h3 {
  color: var(--c-accent-d);
}

.doc-body p {
  font-size: 14px;
  color: var(--c-text-2);
  line-height: 1.6;
}

.doc-arrow {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--c-subtle);
  color: var(--c-text-3);
  flex-shrink: 0;
  transition: all 0.35s var(--ease);
}

.doc-card:hover .doc-arrow {
  background: linear-gradient(135deg, var(--c-accent), var(--c-violet));
  color: var(--c-white);
  transform: translateX(4px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.doc-card-active {
  border-color: transparent;
  box-shadow: var(--shadow-lg);
  transform: translateY(-4px);
}

.doc-card-active .doc-accent {
  opacity: 1;
}

.doc-card-active .doc-num {
  background: linear-gradient(135deg, var(--c-accent), var(--c-violet));
  color: var(--c-white);
  box-shadow: 0 4px 16px rgba(59, 130, 246, 0.3);
}

.doc-card-active .doc-body h3 {
  color: var(--c-accent-d);
}

.doc-card-active .doc-arrow {
  background: linear-gradient(135deg, var(--c-accent), var(--c-violet));
  color: var(--c-white);
  transform: translateX(4px);
}

/* ===== Screen 3: Video + Process ===== */
.screen-3 {
  background: #f1f5f9;
  align-items: flex-start;
  padding-top: var(--hh);
}

.vid-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 12px;
}

.vid-card {
  background: var(--c-white);
  border-radius: var(--r);
  overflow: hidden;
  cursor: pointer;
  transition: all 0.35s var(--ease);
  box-shadow: var(--shadow-sm);
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.vid-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
  border-color: transparent;
}

.vid-thumb {
  position: relative;
  aspect-ratio: 16 / 9;
  overflow: hidden;
  background: var(--c-dark-2);
}

.vid-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s var(--ease);
}

.vid-card:hover .vid-thumb img {
  transform: scale(1.07);
}

.vid-play {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: all 0.3s var(--ease);
}

.vid-card:hover .vid-play {
  opacity: 1;
}

.vid-card:hover .vid-play svg circle {
  fill: rgba(59, 130, 246, 0.8);
}

.vid-info {
  padding: 22px 24px;
}

.vid-info h3 {
  font-size: 17px;
  font-weight: 600;
  color: var(--c-text);
  margin-bottom: 6px;
  transition: color 0.3s;
}

.vid-card:hover .vid-info h3 {
  color: var(--c-accent);
}

.vid-info p {
  font-size: 14px;
  color: var(--c-text-2);
}

.proc-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 18px;
}

.proc-card {
  position: relative;
  padding: 28px 22px;
  background: var(--c-white);
  border: 1px solid var(--c-border);
  border-radius: var(--r);
  cursor: pointer;
  transition: all 0.35s var(--ease);
  text-align: center;
}

.proc-card:hover {
  border-color: var(--c-accent);
  transform: translateY(-4px);
  box-shadow: var(--shadow-md);
}

.proc-card.is-new {
  background: linear-gradient(135deg, var(--c-accent), var(--c-violet));
  border-color: transparent;
  box-shadow: 0 8px 28px rgba(59, 130, 246, 0.28);
}

.proc-card.is-new:hover {
  box-shadow: 0 16px 40px rgba(59, 130, 246, 0.4);
  transform: translateY(-6px);
}

.proc-card.is-new h3,
.proc-card.is-new p {
  color: var(--c-white);
}

.proc-card.is-new:hover h3 {
  color: rgba(255, 255, 255, 0.8);
}

.badge-new {
  position: absolute;
  top: -10px;
  right: -10px;
  padding: 3px 10px;
  background: linear-gradient(135deg, #f97316, #ef4444);
  color: var(--c-white);
  font-size: 11px;
  font-weight: 700;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
  letter-spacing: 0.5px;
}

.proc-card h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--c-text);
  margin-bottom: 6px;
  transition: color 0.3s;
}

.proc-card:hover h3 {
  color: var(--c-accent);
}

.proc-card p {
  font-size: 13px;
  color: var(--c-text-2);
  line-height: 1.5;
  transition: color 0.3s;
}

/* ===== Footer ===== */
.footer {
  background: var(--c-dark);
  color: var(--c-text-3);
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

.footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 72px 40px 40px;
}

.footer-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 32px;
}

.footer-col h4 {
  font-size: 14px;
  color: var(--c-white);
  font-weight: 600;
  margin-bottom: 20px;
  letter-spacing: 0.5px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.footer-col ul {
  list-style: none;
}

.footer-col li {
  margin-bottom: 10px;
}

.footer-col a {
  font-size: 14px;
  color: rgba(148, 163, 184, 0.8);
  cursor: pointer;
  transition: color 0.2s var(--ease);
  line-height: 1.5;
}

.footer-col a:hover {
  color: var(--c-accent-l);
}

.footer-qr {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  justify-content: flex-end;
}

.qr-block {
  text-align: center;
  font-size: 13px;
}

.qr-block img {
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.qr-block p {
  color: rgba(148, 163, 184, 0.8);
  line-height: 1.6;
}

.footer-line {
  height: 1px;
  background: rgba(148, 163, 184, 0.10);
  margin: 40px 0 20px;
}

.footer-copy {
  text-align: center;
  font-size: 13px;
  color: rgba(148, 163, 184, 0.5);
}

/* ===== Transitions ===== */
.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s var(--ease);
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.modal-enter-active {
  transition: all 0.35s var(--ease);
}

.modal-leave-active {
  transition: all 0.25s var(--ease);
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

/* ===== Responsive ===== */
@media (max-width: 1200px) {
  .nav {
    gap: 20px;
    margin-left: 32px;
  }

  .nav-group {
    gap: 20px;
  }

  .nav-divider {
    margin: 0 16px;
  }

  .template-row {
    grid-template-columns: repeat(3, 1fr);
  }

  .tpl-card {
    width: auto;
  }

  .proc-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .vid-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 1024px) {
  .header-inner {
    padding: 0 28px;
  }

  .nav {
    gap: 12px;
    margin-left: 16px;
  }

  .nav>a:not(.nav-primary),
  .nav-group>a {
    font-size: 14px;
  }

  .nav-group {
    gap: 16px;
  }

  .nav-divider {
    margin: 0 10px;
  }

  .footer-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .vid-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 18px;
  }

  .proc-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .screen-center {
    padding: 80px 28px;
  }

  .sec-title {
    font-size: 36px;
  }

  .sec-badge {
    font-size: 11px;
    letter-spacing: 3px;
  }
}

@media (max-width: 768px) {
  :root {
    --hh: 60px;
  }

  .nav,
  .btn-support {
    display: none;
  }

  .btn-menu {
    display: flex;
  }

  .mobile-nav {
    display: flex;
  }

  .header-inner {
    padding: 0 20px;
  }

  .screen-1-content {
    gap: 44px;
    padding: 44px 20px 64px;
  }

  .hero-top {
    margin-bottom: 20px;
  }

  .hero-desc {
    margin-bottom: 28px;
  }

  .hero-actions {
    gap: 12px;
  }

  .btn {
    padding: 12px 28px;
    font-size: 15px;
  }

  .template-row {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  .tpl-card {
    width: auto;
  }

  .tpl-icon {
    height: 100px;
  }

  .tpl-card h3 {
    font-size: 14px;
    padding: 14px 12px 0;
  }

  .tpl-card p {
    font-size: 12px;
    padding: 0 12px 14px;
  }

  .screen-center {
    padding: 64px 20px;
  }

  .sec-title {
    font-size: 28px;
    margin-bottom: 10px;
  }

  .sec-sub {
    font-size: 15px;
    margin-bottom: 36px;
  }

  .sec-title-sm {
    font-size: 22px;
    margin-top: 48px;
    margin-bottom: 28px;
  }

  .doc-grid {
    grid-template-columns: 1fr;
    gap: 14px;
  }

  .doc-card {
    padding: 22px 20px;
    gap: 16px;
  }

  .doc-num {
    width: 46px;
    height: 46px;
    font-size: 18px;
    border-radius: 12px;
  }

  .doc-body h3 {
    font-size: 16px;
  }

  .doc-body p {
    font-size: 13px;
  }

  .vid-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }

  .vid-info {
    padding: 16px 18px;
  }

  .vid-info h3 {
    font-size: 15px;
  }

  .vid-info p {
    font-size: 13px;
  }

  .proc-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }

  .proc-card {
    padding: 22px 16px;
  }

  .proc-card h3 {
    font-size: 16px;
  }

  .proc-card p {
    font-size: 12px;
  }

  .footer-grid {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .footer-col:not(.footer-qr) {
    display: none;
  }

  .footer-qr {
    justify-content: center;
  }

  .modal-box {
    padding: 28px;
  }

  .modal-qr {
    gap: 16px;
  }

  .qr-card img {
    width: 120px;
    height: 120px;
  }

  .footer-inner {
    padding: 48px 20px 32px;
  }
}

@media (max-width: 480px) {
  :root {
    --hh: 56px;
    --r: 12px;
  }

  .brand span {
    font-size: 18px;
  }

  .screen-1-content {
    gap: 36px;
    padding: 36px 16px 52px;
  }

  .hero-tagline {
    font-size: 26px;
  }

  .hero-badge {
    padding: 5px 14px;
    font-size: 12px;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .btn {
    width: 100%;
    max-width: 280px;
  }

  .template-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .tpl-icon {
    height: 80px;
  }

  .tpl-card h3 {
    font-size: 13px;
  }

  .tpl-card p {
    font-size: 11px;
  }

  .screen-center {
    padding: 52px 16px;
  }

  .sec-title {
    font-size: 24px;
  }

  .sec-sub {
    margin-bottom: 28px;
    font-size: 14px;
  }

  .sec-title-sm {
    font-size: 20px;
    margin-top: 36px;
    margin-bottom: 24px;
  }

  .sec-badge {
    font-size: 10px;
    letter-spacing: 2px;
  }

  .doc-card {
    padding: 18px 16px;
    gap: 14px;
  }

  .doc-num {
    width: 40px;
    height: 40px;
    font-size: 16px;
    border-radius: 10px;
  }

  .doc-body h3 {
    font-size: 15px;
  }

  .doc-body p {
    font-size: 12px;
  }

  .vid-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .vid-info {
    padding: 14px 16px;
  }

  .proc-grid {
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .proc-card {
    padding: 18px 14px;
  }

  .proc-card h3 {
    font-size: 15px;
  }

  .proc-card p {
    font-size: 12px;
  }

  .modal-qr {
    grid-template-columns: 1fr;
  }

  .qr-card img {
    width: 110px;
    height: 110px;
  }

  .scroll-hint {
    bottom: 24px;
  }

  .footer-inner {
    padding: 40px 16px 28px;
  }
}
</style>
